import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const MeasurementUnitApiResources = {
  list:  createUrl('measurement-units'),
  create:  createUrl('measurement-units/create'),
  detail:  createUrl('measurement-units'),
  update:  createUrl('measurement-units'),
  delete:  createUrl('measurement-units')
};
